//#region types
import { AutomationRuleEnums, DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
import RuleCreationFormContainer from "./ruleCreationFormContainer";
import { Grid } from "@mui/material";
import { Icon, RoundButton } from "components/common";
import useDeleteConfirmation from "./useDeleteConfirmation";
import { useAutomationRuleService } from "serviceHooks";
//#region  components
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

function useCreateAutomationRuleDialog() {
  const automationRuleService = useAutomationRuleService();
  const { showDeleteConfirmation } = useDeleteConfirmation();
  const onDeleteClick = async (
    ruleId?: string,
    type?: AutomationRuleEnums.AutomationRuleType,
    onDeleteSuccess?: () => void,
    closeDialog?: () => void
  ) => {
    const onDelete = async () => {
      if (ruleId && type) {
        switch (type) {
          case AutomationRuleEnums.AutomationRuleType.ReceiptDraft:
            await automationRuleService.deleteReceitpDraftRule(ruleId);
            break;
          default:
            throw new Error(`Unsupported automation rule type: ${type}`);
        }
      }

      closeDialog && closeDialog();
      setTimeout(() => {
        onDeleteSuccess && onDeleteSuccess();
      });
    };

    showDeleteConfirmation(onDelete);
  };

  const getCreateDialog = (
    ruleId?: string,
    type?: AutomationRuleEnums.AutomationRuleType,
    onSubmitSuccess?: () => void
  ): DialogProps => {
    const isEdit = !!ruleId && !!type;
    return {
      isOpen: false,
      title: isEdit
        ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AutomationRule.EditRule)
        : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AutomationRule.AddRule),
      titleIcon: IconDefinitionConstants.WBolt,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Submit),
          successMessage: TranslationKeys.AutomationRule.CreateSuccess,
        },
      ],
      footer: isEdit
        ? (closeDialog, isValid) => (
            <Grid item xs alignItems="flex-end">
              <Grid item>
                <RoundButton
                  className={cssExports.delete}
                  disabled={!isValid}
                  onClick={onDeleteClick.bind(null, ruleId, type, onSubmitSuccess, closeDialog)}
                >
                  <Icon icon={IconDefinitionConstants.WTrashAlt} />
                </RoundButton>
              </Grid>
            </Grid>
          )
        : undefined,
      dialogType: DialogEnums.DialogType.Content,
      children: <RuleCreationFormContainer ruleId={ruleId} type={type} />,
      maxWidth: "sm",
      onSubmit: onSubmitSuccess,
    };
  };

  return getCreateDialog;
}

export default useCreateAutomationRuleDialog;
